// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"81":"723d1ade","325":"77ada104","844":"e0a366eb"}[chunkId] + ".chunk.css";
};